import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import HeritageLogo from "./HeritageLogo";

const Footer = () => {
  return (
    <footer className="bg-[#0F172A] text-[#E2E8F0]" data-testid="site-footer">
      <div className="hccbt-container py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <HeritageLogo className="h-10 w-auto" onDark />
          <p className="mt-5 text-sm leading-relaxed text-[#94A3B8] max-w-md">
            Heritage Career College of Business and Technology is a new,
            career-focused college based in Ontario — preparing graduates for
            meaningful careers across Canada's evolving economy.
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <div className="flex items-center gap-3 text-[#CBD5E1]">
              <Phone size={16} className="text-[#87CEEB]" />
              <a
                href="tel:+16043076440"
                className="hover:text-white"
                data-testid="footer-phone-link"
              >
                +1 (604) 307-6440
              </a>
            </div>
            <div className="flex items-center gap-3 text-[#CBD5E1]">
              <Mail size={16} className="text-[#87CEEB]" />
              <a
                href="mailto:info@hccbt.com"
                className="hover:text-white"
                data-testid="footer-email-link"
              >
                info@hccbt.com
              </a>
            </div>
            <div className="flex items-center gap-3 text-[#CBD5E1]">
              <MapPin size={16} className="text-[#87CEEB]" />
              <span>Ontario, Canada</span>
            </div>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">
            Explore
          </h4>
          <ul className="space-y-3 text-sm text-[#CBD5E1]">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/programs" className="hover:text-white">Programs</Link></li>
            <li><Link to="/admissions" className="hover:text-white">Admissions</Link></li>
            <li><Link to="/faculty" className="hover:text-white">Faculty</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">
            Connect
          </h4>
          <ul className="space-y-3 text-sm text-[#CBD5E1]">
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><span className="text-[#64748B]">Campus Life — coming soon</span></li>
            <li><span className="text-[#64748B]">News & Events — coming soon</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="hccbt-container py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#94A3B8]">
          <p>© {new Date().getFullYear()} Heritage Career College of Business and Technology. All rights reserved.</p>
          <p>Ontario, Canada · Career-focused, learner-first.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
